export class GradeLotNoRequest {
    lotNo: string;
    plantId: number;
    year?:number

    constructor(lotNo: string,plantId: number,year?:number){
        this.lotNo = lotNo;
        this.plantId = plantId;
        this.year = year
    }
}